import React, { useState, useEffect } from "react";
import { CONFIG } from "../config";
import { ArrowRight, Flame } from "lucide-react";

export default function MobileStickyCta() {
  const [showSticky, setShowSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroCta = document.getElementById("hero-cta");
      const footer = document.getElementById("main-footer");
      if (!heroCta) return;

      const heroCtaRect = heroCta.getBoundingClientRect();
      const scrolledPastHero = heroCtaRect.bottom < 0;

      let footerInView = false;
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        footerInView = footerRect.top < window.innerHeight;
      }

      setShowSticky(scrolledPastHero && !footerInView);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!showSticky) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-brand-dark/95 backdrop-blur-md border-t-2 border-brand-red py-3 px-4 shadow-xl md:hidden animate-in fade-in slide-in-from-bottom duration-300">
      <div className="max-w-md mx-auto">
        <a
          href="#final-buy-box"
          onClick={(e) => {
            e.preventDefault();
            document.getElementById("final-buy-box")?.scrollIntoView({ behavior: "smooth", block: "center" });
          }}
          data-testid="mobile-sticky-cta-button"
          className="w-full py-3 px-3 bg-brand-cta hover:bg-brand-cta-hover text-white rounded-lg font-sans font-extrabold uppercase text-[10px] sm:text-xs tracking-wide flex items-center justify-center gap-1.5 border-b-2 border-black/40 hover:border-b-0 cursor-pointer shadow-md whitespace-nowrap"
        >
          YES! I&rsquo;M READY TO REMOVE MY COLLECTIONS
          <ArrowRight className="w-3.5 h-3.5 shrink-0" />
        </a>
      </div>
    </div>
  );
}
